import { isPlatformBrowser } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, Inject, Optional, PLATFORM_ID } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import readXlsxFile from 'read-excel-file';
import { firstValueFrom, Subscription } from 'rxjs';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { CostCenterPriceImportModel } from './../../../../models/imports/cost-center-price-import-model';
import { CostCenterPriceService } from './../../../../services/archive/cost-center-price.service';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';

@Component({
  selector: 'app-import-cost-center-price',
  templateUrl: './import-cost-center-price.component.html',
  styleUrls: ['./import-cost-center-price.component.scss'],
  standalone: false
})
export class ImportCostCenterPriceComponent {

  costCenterPriceAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  costCenterPriceImport: boolean = false;
  errorCostCenterPrice: number = 0;
  eventFile: any;
  listObservers: Array<Subscription> = new Array<Subscription>();
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = '';
  swFacturacionEspecial: boolean = false;
  visibleTxt: boolean = false;

  constructor(
    private costCenterPriceService: CostCenterPriceService,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef,
    @Inject(PLATFORM_ID) private platformId: object) {
    this.getSwFacturacionEspecial();
  }

  attach() {
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('fileImport')?.click();
    }
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      if (isPlatformBrowser(this.platformId)) {
        this.eventFile.target.value = '';
      }
    }
  }

  close() {
    const data: ModalObjectType = {};
    if (this.costCenterPriceImport) {
      data.params = { reload: true };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  downloadGuideImport() {
    this.costCenterPriceService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaPreciosCentroCostos.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  downloadErrorsTxt() {
    if (!this.costCenterPriceAlerts || this.costCenterPriceAlerts.length === 0) {
      this.toastHandlerService.showToast(
        'error',
        'No hay alertas para exportar'
      );
      return;
    }

    this.costCenterPriceService.exportImportErrors(this.costCenterPriceAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionPreciosPorCCostos_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast(
          'error',
          'Error al exportar el archivo'
        );
      }
    });
  }

  getSwFacturacionEspecial() {
    const load = this.costCenterPriceService.getSwFacturacionEspecial().subscribe(response => {
      this.listObservers.push(load);
      this.swFacturacionEspecial = response;
    });
  }

  importCostCenterPrices() {
    this.costCenterPriceAlerts = [];
    this.errorCostCenterPrice = 0;
    this.visibleTxt = false;
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (!isPlatformBrowser(this.platformId)) return;
    let isOk: boolean = true;
    const input = document.getElementById("fileImport") as any;
    const rowsImports = new Array<CostCenterPriceImportModel>();
    let row: CostCenterPriceImportModel;
    let counter: number = 1, branchCode: number, costCenterCode: number, conceptInvoicingCode: number,
      articleCode: number, swIsInvoiced: boolean, swInvoiceM2: boolean, unitValue: number, quantityEspecialInvoicing: number;

    if (!input.files[0]) {
      this.toastHandlerService.showToast(
        'error',
        'No ha seleccionado ningún archivo.'
      );
      return;
    }

    readXlsxFile(input.files[0]).then(async (rows) => {
      if (rows.length <= 1) {
        this.toastHandlerService.showToast(
          'error',
          'El archivo ingresado no tiene registros para importar.'
        );
        return;
      }
      rows.splice(0, 1);
      rows.forEach(element => {
        counter = counter + 1;
        let rowHasError = false;

        //A. Código Sucursal:
        branchCode = parseFloat(element[0] as string);
        if (isNaN(branchCode)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna A. El código de la sucursal no es válido.`;
          this.costCenterPriceAlerts.push(alert);
          rowHasError = true;
        }

        //B. Código Centro Costos:
        costCenterCode = parseFloat(element[1] as string);
        if (isNaN(costCenterCode)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna B. El código del centro de costos no es válido.`;
          this.costCenterPriceAlerts.push(alert);
          rowHasError = true;
        }

        //C. Código Concepto Fra.:
        conceptInvoicingCode = parseFloat(element[2] as string);
        if (isNaN(conceptInvoicingCode)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna C. El código del concepto fra. no es válido.`;
          this.costCenterPriceAlerts.push(alert);
          rowHasError = true;
        }
        //Si no tiene swFacturacionEspecial, siempre debería el código 1: Alquiler
        if (!this.swFacturacionEspecial && conceptInvoicingCode != 1) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna C. Se debe ingresar el código del concepto fra. de alquiler. (1)`;
          this.costCenterPriceAlerts.push(alert);
          rowHasError = true;
        }

        //D. Código Artículo:
        articleCode = parseFloat(element[3] as string);
        if (isNaN(articleCode)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna D. El código del artículo no es válido.`;
          this.costCenterPriceAlerts.push(alert);
          rowHasError = true;
        }

        // E. Cantidad:
        quantityEspecialInvoicing = parseFloat(element[4] as string);
        if (this.swFacturacionEspecial) {
          if (isNaN(quantityEspecialInvoicing)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna E. La cantidad no es válida.`;
            this.costCenterPriceAlerts.push(alert);
            rowHasError = true;
          }
        } else {
          quantityEspecialInvoicing = 1;
        }

        //F. Factura :
        if (element[5] as string != "S" && element[5] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna F. El campo factura debe ser valores como: S / N.`;
          this.costCenterPriceAlerts.push(alert);
          rowHasError = true;
        }
        swIsInvoiced = element[5] as string === "S";

        //G. Unidad en M2:
        if (element[6] as string != "M" && element[6] as string != "U") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Coumna G. El campo factura debe ser valores como: U / M.`;
          this.costCenterPriceAlerts.push(alert);
          rowHasError = true;
        }
        swInvoiceM2 = element[6] as string === "M";

        // H. Valor Unitario:
        unitValue = parseFloat(element[7] as string);
        if (isNaN(unitValue)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna H. El valor unitario no es válido.`;
          this.costCenterPriceAlerts.push(alert);
          rowHasError = true;
        }

        if (!rowHasError) {
          row = new CostCenterPriceImportModel(counter, branchCode, costCenterCode, conceptInvoicingCode,
            articleCode, quantityEspecialInvoicing, swIsInvoiced, swInvoiceM2, unitValue);
          rowsImports.push(row);
        } else {
          isOk = false;
        }
      });

      if (!isOk || rowsImports.length === 0) {
        this.errorCostCenterPrice = 1;
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea'
        );
        return;
      }

      await this.processImportCostCenterPrices(rowsImports);
    });
  }

  async processImportCostCenterPrices(rowsImports: Array<CostCenterPriceImportModel>) {
    try {
      const response = await firstValueFrom(this.costCenterPriceService.importCostCenterPrices(rowsImports));
      this.loadPreInvoicingModel = response;
      this.costCenterPriceAlerts = response?.alerts ?? [];
      this.errorCostCenterPrice = response?.preInvoicingStateId;

      if (this.errorCostCenterPrice === 1) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea',
          'ERROR'
        );
      } else if (this.costCenterPriceAlerts.length > 0) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con alertas, puede exportarlas si lo desea'
        );
      } else {
        this.visibleTxt = false;
        this.costCenterPriceImport = true;
        this.toastHandlerService.showToast(
          'success',
          `La importación terminó exitosamente.`
        );
        this.close();
      }
      this.clearInputFile();
    } catch (error) {
      this.nameFile = 'Ningún archivo seleccionado.';
      console.error('Error al importar Precios por Centros de Costos.', error);
    }
  }
}
